import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import eth_icon from "../imgs/eth_icon_blue.svg";
import styled from "styled-components";
import MasterCopy from "../common/models/MasterCopy";
import SimpleButton from "../components/Buttons/SimpleButton";
import Column from "../components/Column/Column";
import InputWithIcon from "../components/Inputs/InputWithIcon";
import ComposeLogoLink from "../components/Link/ComposeLogoLink";
import Row from "../components/Row/Row";
import Text from "../components/Text/Text";
import { Timeline } from "../components/Timeline/Timeline";
const decimalNumberRegex = /^\d*\.?\d+$/;

interface SubscriberCountPageState {
  timelineEvents: Array<string>;
  selectedLicense: string;
  song: MasterCopy;
}

interface SubscriberCountPageProps {
  theme: string;
  toggleTheme: any;
}

const SubsciberCountContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background: #000D30;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;

const SubscriberCountBox = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 30%;
  border-radius: 20px;
  border: 1px solid #ffffff90;
  background: #000D30;
  padding: 2rem;
  align-items: center;
  justify-content: center;
`;
const ActionContainer = styled.div`
  position: absolute;
  width:50%;
  background: #9D7CFF;
  padding: 1%;
  opacity: 0.9;
  border-radius: 1px;
  left: 25%;
  right: 25%;
  bottom: 20%;
  text-align: center;
`;

const EthText = styled.p`
  color: #03BBF5;
`;

const NextButton = styled(SimpleButton)`
  position: absolute;
  right: 10%;
  bottom: 10%;
`;

const NextButtonLight = styled(SimpleButton)`
  position: absolute;
  right: 10%;
  bottom: 10%;
`;

export const SubscriberCountPage = ({
  theme,
  toggleTheme,
}: SubscriberCountPageProps) => {
  const { state } = useLocation();
  const locationState = state as SubscriberCountPageState;
  const navigate = useNavigate();
  const [smallPrice, setSmallPrice] = useState("");
  const [mediumPrice, setMediumPrice] = useState("");
  const [largePrice, setLargePrice] = useState("");
  const [nextEnabled, setNextEnabled] = useState(false);
  const [sizeSelected, setSizeSelected] = useState("");

  const onNextClick = () => {
    navigate("/terms_and_conditions", {
      state: {
        timelineEvents: locationState.timelineEvents,
        selectedLicense: locationState.selectedLicense,
        smallPrice: smallPrice,
        mediumPrice: mediumPrice,
        largePrice: largePrice,
        selectedSize: sizeSelected,
        song: locationState.song,
      },
    });
  };

  const onSmallLicenseChange = (
    changeEvent: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSizeSelected("small");
    setSmallPrice(changeEvent.target.value);
    nextButtonState();

  };

  const onMediumLicenseChange = (
    changeEvent: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSizeSelected("medium");
    setMediumPrice(changeEvent.target.value);
    nextButtonState();
  };

  const onLargeLicenseChange = (
    changeEvent: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSizeSelected("large");
    setLargePrice(changeEvent.target.value);
    nextButtonState();

  };

  const nextButtonState = () => {
    if (decimalNumberRegex.test(smallPrice) && decimalNumberRegex.test(mediumPrice) && decimalNumberRegex.test(largePrice)) {
      setNextEnabled(true);
    }
    else {
      setNextEnabled(false);
    }
  }

  return (
    <>
      <ComposeLogoLink />
      <SubsciberCountContainer>
        <Timeline events={locationState.timelineEvents} currentEventIndex={1} />

        <Column
          style={{
            justifyContent: "center",
            alignItems: "center",
            gap: "50px",
          }}
        >
          <Text>
            Please enter the amount you wish to set for different ranges of
            YouTube subscriber counts
          </Text>
          <Row gap={"5%"}>
            <SubscriberCountBox>
              <Text style={{ textAlign: "center" }} bold={true} size={"24px"}>
                Small up to
                <br></br>
                250k
              </Text>

              <Row gap={"10px"}>
                <InputWithIcon
                  onChange={onSmallLicenseChange}
                  src={eth_icon}
                  placeholder={"enter price"}
                />
                <EthText>ETH</EthText>
              </Row>
            </SubscriberCountBox>

            <SubscriberCountBox>
              <Text style={{ textAlign: "center" }} bold={true} size={"24px"}>
                Medium up to
                <br></br>1 million
              </Text>

              <Row gap={"10px"}>
                <InputWithIcon
                  onChange={onMediumLicenseChange}
                  src={eth_icon}
                  placeholder={"enter price"}
                />
                <EthText>ETH</EthText>
              </Row>
            </SubscriberCountBox>

            <SubscriberCountBox>
              <Text style={{ textAlign: "center" }} bold={true} size={"24px"}>
                Large up to
                <br></br>1 million +
              </Text>

              <Row gap={"10px"}>
                <InputWithIcon
                  onChange={onLargeLicenseChange}
                  src={eth_icon}
                  placeholder={"enter price"}
                />
                <EthText>ETH</EthText>
              </Row>
            </SubscriberCountBox>
          </Row>

          <Row>
            <ActionContainer>
            *Note: all licenses will be sold at the <b>lowest prices</b> during ComposeNFT Beta. Price differential will go into effect after the ComposeNFT beta phase.
            </ActionContainer>
          </Row>
            {!nextEnabled ? <NextButton disabled>Next</NextButton> :
              <NextButton onClick={onNextClick} bg="primary">
                Next
              </NextButton>}


        </Column>


      </SubsciberCountContainer>
    </>
  );
};
